import PatientPoolTransformer from "@/Modules/Transformers/PatientPool";

import { getPatientsPoolList } from "@/Services/TherapyApi/PatientsPool";

import usePatientPoolStore from "@/Modules/PatientsPool/Store";

import { log } from "@/Utils/Debug";

const patientPoolTransformer = PatientPoolTransformer;

function getPatientsAH(userId: string) {
  const patientsPoolStore = usePatientPoolStore();

  patientsPoolStore.isLoading = true;

  getPatientsPoolList(userId)
    .then((res) => {
      patientsPoolStore.patientsPool = res.map(patientPoolTransformer.toDomain);
    })
    .catch(log)
    .finally(() => {
      patientsPoolStore.isLoading = false;
    });
}

export default getPatientsAH;
